export default __webpack_public_path__ + "static/media/datatwinLogonew.2bae8655.png";